import { Icon } from "@src/components/ui-kit/Icon";
import { ButtonLink } from "@src/components/ui-kit/Link";
import type React from "react";
import type { FC } from "react";

interface Props {
  url?: string | null;
}

export const ViewInvoiceButton: FC<React.PropsWithChildren<Props>> = ({
  url,
  children,
}) => {
  return (
    <ButtonLink
      isExternal
      href={url || ""}
      isDisabled={!url}
      colorScheme="grey"
      variant="outline"
      leftIcon={<Icon name="eye" />}
      target="_blank"
      size="sm"
    >
      {children}
    </ButtonLink>
  );
};
